export function size(res) {
  let docEl = document.documentElement,
    clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (!clientWidth) return;
  let size
  if (clientWidth <= 1680) {
    size = 100 * (clientWidth / 1800);
  } else {
    size = 100 * (clientWidth / 1920);
  }
  return res * size;
}
export default {
  size
}



// WEBPACK FOOTER //
// ./src/public/resetsize.js